import { PopulationCsvDownloadButton as Button } from './PopulationCsvDownloadButton';
import { PopulationCsvDownloadTrigger as Trigger } from './PopulationCsvDownloadTrigger';

const PopulationCsvDownload = {
  /**
   * Pre-styled button that triggers the CSV file download for the current `PopulationCsvDownload` context.
   *
   * If you'd like to customize the button beyond passing basic `Button` props, use the `Trigger` component instead.
   */
  Button,
  /**
   * Wraps a custom element that will be used to trigger a CSV file download on click.
   */
  Trigger,
};

export { PopulationCsvDownload };
